import {DndContext, useDroppable} from "@dnd-kit/core"
import React, {useEffect, useRef} from "react"
import {Box, Grid, Typography} from "@mui/material"
import DraggableEvent from "./DraggableEvent"
import Backgroundfamily from "../../assets/images/family.jpg"
import _ from "lodash" 
import DraggableItem from "./DraggableItem"

export const widgetDndBoardPrototype = [
        {
          "key": "typ",
          "type": "STRING",
          "label": "Typ",
          "size": 3
        },
        {
          "key": "objects",
          "type": "SELECTTREE",
          "label": "Objekte",
          "size": 6,
          "options": "objekte"
        }
      ]

const BoardStyle = {
    borderRadius: "16px",
    padding: "16px",
    minHeight: "900px",
    width: "100%",
    backgroundImage: `url(${Backgroundfamily})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
}

const ITEM_WIDTH = 120
const HALF_ITEM_WIDTH = 60
const HALF_ITEM_HEIGHT = 60

const WidgetDndBoard = ({widget, value, onValueChange}) => {
    
    useEffect(() => {
        if(!_.isArray(value) || value.length === 0) {
            onValueChange(widget.objects?.origin.children ?? [])
        }
    }, [])
    
    const dropareaRef = useRef(null)
    const {setNodeRef: setSourceNodeRef} = useDroppable({
        id: "source",
    })

    const handleDragEnd = event => {
        const {active,activatorEvent, delta} = event
        const dropAreaPos = dropareaRef.current.getBoundingClientRect()
        onValueChange(
            value.map(item => {
                if (item.id === active.id) {
                    const startPosition = item.position || {x: activatorEvent.clientX - dropAreaPos.left - HALF_ITEM_WIDTH, y: activatorEvent.clientY - dropAreaPos.height - HALF_ITEM_HEIGHT}

                    return {
                        ...item,
                        position: {
                            x: startPosition.x + delta.x,
                            y: startPosition.y + delta.y,
                        },
                    }
                }
                return item
            }),
        )
    }

    const positionedItems = _.isArray(value) ? value.filter(item => item.position) : []
    const initialItems = _.isArray(value) ? value.filter(item => !item.position) : []

    return (
        <DndContext onDragEnd={handleDragEnd}>
            <Box
                ref={node => { dropareaRef.current = node }}
                sx={{mt: 3, position: "relative"}}
                display="flex"
                flexDirection="column"

            >
                <Box style={BoardStyle} />
                
                <Grid container ref={setSourceNodeRef} sx={{ position: 'relative' }}> 
                    
                    {positionedItems.map(item => (
                        <DraggableItem
                            key={item.id}
                            item={item}
                            defaultPosition={item.position} 
                            sx={{
                                position: 'absolute',
                                left: item.position.x, 
                                top: item.position.y
                            }}
                        >
                            <Typography fontSize="14px" color="#ffffff">{item.longname}</Typography>
                        </DraggableItem>
                    ))}
                    
                    <Grid container spacing={2}>
                        {initialItems.map(item => (
                            <Box
                                key={item.id + "box"}
                                width={`${ITEM_WIDTH}px`}
                                height={`${ITEM_WIDTH}px`}
                                sx={{ position: 'relative' }} 
                            >
                                <DraggableItem
                                    key={item.id}
                                    item={item}
                                    defaultPosition={{x: 0, y: 0}}
                                >
                                    <Typography
                                        fontSize="14px"
                                        color="#ffffff"
                                    >
                                        {item.longname}
                                    </Typography>
                                </DraggableItem>
                            </Box>
                        ))}
                    </Grid>
                </Grid>
            </Box>
        </DndContext>
    )
}

export default WidgetDndBoard